module.exports = __webpack_public_path__ + "img/changelly_gray.b768a2fe.png";